export const getNumberByPx = (px: string | null) => parseFloat(px ? px.replace('px', '') : '0px')

export const formatNumber = (n: number | string, precision: number) =>
	+`${Math.round(Number(`${n}e+${precision}`))}e-${precision}`
